import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Fri Oct 26 2018
 * @author PKr
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { Overview, WindowFilter, Pagination, Window, WindowOverviewDTO, WorkflowStatus } from '@logio/common-be-fe';
import { WindowLayer } from '../../transportLayers/window/WindowLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { Map } from 'immutable';
/**
 * Persistent store for Windows
 */

export var WindowStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(WindowStore, _BaseStore);

  function WindowStore() {
    var _this;

    _classCallCheck(this, WindowStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.Window;
    /** Layer contains methods for fetching data */

    _this.windowLayer = new WindowLayer();
    /** List of Windows */

    _this.list = Map();
    _this.listOverview = new Overview(WindowFilter.EMPTY, null, null, new Pagination(WindowStore.PAGE_SIZE, 0, null));
    /** List of Window overviews */

    _this.overviewList = Map();
    /** List of similar Windows */

    _this.similarList = Map();
    /** List of change history sets for Window */

    _this.changeHistoryList = Map();
    return _this;
  }
  /**
   * Fetches Window detail
   * @returns a promise with Window
   * @param id
   */


  _createClass(WindowStore, [{
    key: "getWindowDetail",
    value: function getWindowDetail(id) {
      var _this2 = this;

      return this.windowLayer.findOne(id).then(function (window) {
        runInAction(function () {
          _this2.detail = window;
        });
        return window;
      });
    }
    /**
     * Fetches edited Window detail
     * @returns a promise with Window
     * @param id
     */

  }, {
    key: "getEditedWindowDetail",
    value: function getEditedWindowDetail(id) {
      var _this3 = this;

      return this.windowLayer.getEditedWindow(id).then(function (window) {
        runInAction(function () {
          _this3.detail = window;
        });
        return window;
      });
    }
    /**
     * Fetches overview detail of Window based on filter
     * @param filter
     */

  }, {
    key: "getWindowOverviewDetail",
    value: function getWindowOverviewDetail(filter) {
      var _this4 = this;

      var limit = WindowStore.PAGE_SIZE;
      var pagination = new Pagination(limit, 0, null);
      var overview = new Overview(filter, null, null, pagination);
      return this.windowLayer.overview(overview).then(function (overviews) {
        runInAction(function () {
          _this4.overviewDetail = overviews[0];
        });
        return overviews[0];
      });
    }
    /**
     * Fetches Window workflow detail
     * @param id
     * @returns Promise<WorkflowStatus<WindowStateEnum>>
     */

  }, {
    key: "getWorkflowDetail",
    value: function getWorkflowDetail(id) {
      var _this5 = this;

      return this.windowLayer.workflowState(id).then(function (workflow) {
        runInAction(function () {
          _this5.workflowDetail = workflow;
        });
        return workflow;
      });
    }
    /**
     * Fetches all Windows
     * @returns a promise with all Windows
     */

  }, {
    key: "getAll",
    value: function getAll() {
      var _this6 = this;

      return this.windowLayer.findAll().then(function (windows) {
        _this6.list = _this6.list.clear();
        runInAction(function () {
          windows.forEach(function (window) {
            _this6.list = _this6.list.set(window.id, window);
          });
        });
        return windows;
      });
    }
    /**
     * Fetches all similar Windows based on windowId
     * @param windowId
     * @param sessionId
     * @returns a promise with all Windows
     */

  }, {
    key: "getSimilarWindows",
    value: function getSimilarWindows(windowId, sessionId) {
      var _this7 = this;

      return this.windowLayer.similarWindows(windowId, sessionId).then(function (windows) {
        _this7.similarList.clear();

        runInAction(function () {
          windows.forEach(function (window) {
            _this7.similarList = _this7.similarList.set(window.id, window);
          });
        });
        return windows;
      });
    }
    /**
     * Fetches one Window
     * @returns a promise with Window
     * @param id
     */

  }, {
    key: "getOne",
    value: function getOne(id) {
      var _this8 = this;

      return this.windowLayer.findOne(id).then(function (window) {
        runInAction(function () {
          _this8.list = _this8.list.set(window.id, window);
        });
        return window;
      });
    }
    /**
     * Creates new Window using WindowLayer
     * @param window - new Window that you want to create
     */

  }, {
    key: "create",
    value: function create(window) {
      var _this9 = this;

      return this.windowLayer.create(window).then(function (updatedWindow) {
        runInAction(function () {
          _this9.list = _this9.list.set(updatedWindow.id, updatedWindow);
        });
        return updatedWindow;
      });
    }
    /**
     * Fetches filtered Windows based on the filter.
     * @param filter - filter params
     * @param pageNum
     * @param forUser
     * @param customLimit
     * @returns a promise with all filtered Windows
     */

  }, {
    key: "filter",
    value: function filter(_filter, pageNum) {
      var _this10 = this;

      var forUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var customLimit = arguments.length > 3 ? arguments[3] : undefined;
      var limit = customLimit ? customLimit : WindowStore.PAGE_SIZE;
      var pagination = new Pagination(limit, limit * (pageNum - 1), null);
      var overview = new Overview(_filter, null, null, pagination);
      return this.windowLayer.filter(overview, forUser).then(function (response) {
        runInAction(function () {
          _this10.list = _this10.list.clear();
          response.result.forEach(function (window) {
            _this10.list = _this10.list.set(window.id, window);
          });
          _this10.listOverview = response.overview;
        });
      });
    }
    /**
     * Deletes Window using WindowLayer
     * @param id - id of the Window you want to delete.
     * @returns a promise with Map of all Windows
     */

  }, {
    key: "delete",
    value: function _delete(id) {
      var _this11 = this;

      return this.windowLayer.delete(id).then(function () {
        runInAction(function () {
          _this11.list = _this11.list.delete(id);
        });
        return _this11.list;
      });
    }
    /**
     * Fetches change history set info based on windowId
     * @param windowId
     * @returns a promise with all entity changes
     */

  }, {
    key: "changeHistory",
    value: function changeHistory(windowId) {
      var _this12 = this;

      return this.windowLayer.changeHistory(windowId).then(function (changes) {
        runInAction(function () {
          _this12.changeHistoryList = _this12.changeHistoryList.clear();
          changes.forEach(function (change) {
            _this12.changeHistoryList = _this12.changeHistoryList.set(change.id, change);
          });
        });
        return changes;
      });
    }
    /**
     * Fetches overview of Windows based on filter
     * @param filter
     * @param pageNum
     * @param customLimit
     */

  }, {
    key: "overview",
    value: function overview(filter, pageNum, customLimit) {
      var _this13 = this;

      var limit = customLimit ? customLimit : WindowStore.PAGE_SIZE;
      var pagination = new Pagination(limit, limit * (pageNum - 1), null);
      var overview = new Overview(filter, null, null, pagination);
      return this.windowLayer.overview(overview).then(function (overviews) {
        _this13.overviewList.clear();

        runInAction(function () {
          overviews.forEach(function (result) {
            _this13.overviewList = _this13.overviewList.set(result.id, result);
          });
        });
        return overviews;
      });
    }
  }]);

  return WindowStore;
}(BaseStore);
WindowStore.PAGE_SIZE = 1000;

__decorate([observable, __metadata("design:type", Window)], WindowStore.prototype, "detail", void 0);

__decorate([observable, __metadata("design:type", WindowOverviewDTO)], WindowStore.prototype, "overviewDetail", void 0);

__decorate([observable, __metadata("design:type", WorkflowStatus)], WindowStore.prototype, "workflowDetail", void 0);

__decorate([observable, __metadata("design:type", Object)], WindowStore.prototype, "list", void 0);

__decorate([observable, __metadata("design:type", Overview)], WindowStore.prototype, "listOverview", void 0);

__decorate([observable, __metadata("design:type", Object)], WindowStore.prototype, "overviewList", void 0);

__decorate([observable, __metadata("design:type", Object)], WindowStore.prototype, "similarList", void 0);

__decorate([observable, __metadata("design:type", Object)], WindowStore.prototype, "changeHistoryList", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], WindowStore.prototype, "getWindowDetail", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], WindowStore.prototype, "getEditedWindowDetail", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [WindowFilter]), __metadata("design:returntype", Promise)], WindowStore.prototype, "getWindowOverviewDetail", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], WindowStore.prototype, "getWorkflowDetail", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], WindowStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", Promise)], WindowStore.prototype, "getSimilarWindows", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], WindowStore.prototype, "getOne", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Window]), __metadata("design:returntype", Promise)], WindowStore.prototype, "create", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [WindowFilter, Number, Boolean, Number]), __metadata("design:returntype", Promise)], WindowStore.prototype, "filter", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], WindowStore.prototype, "delete", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], WindowStore.prototype, "changeHistory", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [WindowFilter, Number, Number]), __metadata("design:returntype", Promise)], WindowStore.prototype, "overview", null);